<template>
  <div class="header" :style="topStyle">
    <div class="header-nav">
      <div class="header-logo">
        <router-link to="/">
          
          <img src="https://qie-online-sale-qiniu.wsandos.com/uploads/20201029/c7896e6fbf851cea93513dcd21a61314.png" alt=""  />
          <!-- <img :src="$imgUrl + logo" alt=""  />  -->
          <!-- v-if="logo != ''" -->
        </router-link>
         <!-- v-if="logo != ''" -->
          <img class="certification" src="../../static/images/logo_101.png" alt="">
      </div>
      <ul class="header-list">
        <li
          @mouseenter="mouseEnter(item.id)"
          @mouseleave="mouseLeave"
          v-for="item in headerList"
          :key="item.id"
          @click="pageUrl(item.url, item.id)"
          :class="{ active: item.id == enterIndex || item.id == actIndex }"
        >
          {{ item.desc }}
          <span
            :class="{ active: item.id == enterIndex || item.id == actIndex }"
          ></span>
        </li>
      </ul>
    </div>

    <!-- <transition name="product-down">
      <div
        v-if="showProductModal"
        class="page-tabs"
        @mouseleave="mouseLeaveModal"
      >
        <div class="tab-options">
          <div
            @click="changeTabs(item.id, 'product')"
            class="option"
            :class="{ active: item.id == productIndex }"
            v-for="item in productDown.leftList"
            :key="item.id"
          >
            <img :src="item.image" /><span>{{ item.title }}</span>
          </div>
        </div>

        <div
          class="tab-content"
          v-show="productIndex == item.id"
          v-for="item in productDown.rightList"
          :key="item.id"
        >
          <div class="item" v-for="s_item in item.list" :key="s_item.id" v-show="s_item.title">
            <h2 @click="jumpPages(s_item.url)" >{{ s_item.title }}</h2>

            <div v-if="s_item.noShow">
              <p
                v-for="(d_item, d_index) in s_item.insideList"
                :key="d_index"
                @click="jumpPages(d_item.url)"
              >
                {{ d_item.desc }}
              </p>
            </div>

            <p v-else>{{ s_item.desc }}</p>
          </div>
        </div>
      </div>
    </transition> -->

    <transition name="solve-down">
      <div
        v-if="showSolveModal"
        class="page-tabs"
        @mouseleave="mouseLeaveModal"
      >
        <div class="tab-options">
          <div
            @click="changeTabs(item.id, 'solve')"
            class="option"
            v-for="item in solveDown.leftList"
            :class="{ active: item.id == solveIndex }"
            :key="item.id"
          >
            <img :src="item.img" />
            <span ref="opTitle">{{ item.title }}</span>
          </div>
        </div>

        <div
          class="tab-content"
          v-show="solveIndex == item.id"
          v-for="item in solveDown.rightList"
          :key="item.id"
        >
          <div
            class="item solve"
            @click="jumpPages(s_item.url, s_item.id,s_item.name,s_item.sub_name)"
            v-for="s_item in item.list"
            :key="s_item.id"
            :class="{ sys: item.id == 4 }"
          >
            <div :class="{ y_color: 1 == s_item.id}">
              <h2>{{ s_item.title }}</h2>

              <p>{{ s_item.desc }}</p>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <div class="swiper-container header-swiper-container" v-if="showSwiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="image in imgList" :key="image.id">
          <img :src="image.pc_image" alt="" class="bannerImg" />
        </div>
      </div>
    </div>
    <div class="swiper-pagination" v-if="showSwiper"></div>

    <div class="big-title" v-if="titleObj.title">
      <h2>{{ titleObj.title }}</h2>
      <p>{{ titleObj.desc }}</p>
      <div class="btn" @click="jumpService">立即咨询</div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  name: "Header",
  props: {
    actIndex: Number,
    imgList: {
      type: Array,
      default: () => [],
    },
    topStyle: String,
    logo: String,
    bigTitle: String,
    titleObj: {
      type: Object,
      default: function () {
        return {};
      },
    },

    // productType: Array
  },
  data() {
    return {
      enterIndex: -1,
      solveIndex: 4,
      productIndex: 1,
      showProductModal: false,
      showSolveModal: false,
      lveDown: '',
      status:false,
      // typeName: '',
      headerList: [
        {
          id: 0,
          desc: "首页",
          dropDown: [],
          url: "/",
        },
        {
          id: 1,
          desc: "软件研发",
          url: "/custom",
        },
        {
          id: 9,
          desc: "广告投放",
          url: "/AdPutting",
        },
        {
          id: 2,
          desc: "FA融资",
          url: "/FAfinancing", 
        },
        {
          id: 3,
          desc: "解决方案",
          url: "/",
        },
        {
          id: 4,
          desc: "案例中心",
          url: "/cases",
        },
        {
          id: 5,
          desc: "服务中心",
          url: "/service",
        },
        {
          id: 6,
          desc: "合作加盟",
          url: "/teamwork",
        },
        // {
        //   id: 7,
        //   desc: "新闻中心",
        //   dropDown: [],
        //   url: "/news",
        // },
        {
          id: 8,
          desc: "关于我们",
          url: "/about",
        },
      ],
      productDown: {
        leftList: [
          {
            id: 0,
            title: "智慧地产生态链",
            img: require("../../static/images/estate.png"),
          },
          {
            id: 1,
            title: "5G彩信",
            img: require("../../static/images/5G.png"),
          },
          {
            id: 2,
            title: "免单营销节",
            img: require("../../static/images/md.png"),
          },
        ],
        rightList: [
          {
            id: 0,
            list: [
              {
                id: 0,
                title: "智慧营销体系",
                desc: "构建完美创新智慧营销模式",
                url: "/craftProduct",
                noShow: true,
                insideList: [
                  { url: "/wisdomMarket/spread", desc: "智慧传播" },
                  { url: "/wisdomMarket/case", desc: "智慧案场" },
                  { url: "/wisdomMarket/channel", desc: "智慧渠道" },
                ],
              },
              {
                id: 1,
                title: "智慧经营体系",
                desc: "打造房产生态经营体系智慧模式",
                noShow: true,
                insideList: [{ url: "", desc: "智慧售楼系统" }],
              },
              {
                id: 2,
                title: "智慧生活体系",
                noShow: true,
                desc: "助力企业快熟搭建智慧生活格局",
                url: "",
              },
            ],
          },
          {
            id: 1,
            list: [
              {
                id: 0,
                title: "短信营销方案",
                desc: "实时互动，链起您与用户的沟通桥梁",
                url: "/five_g",
              },
            ],
          },
          {
            id: 2,
            list: [
              {
                id: 0,
                title: "免单营销节解决方案",
                desc: "创造属于自己的城市营销解决方案",
                url: "/freeMarket",
              },
            ],
          },
        ],
      },
      solveDown: {
        leftList: [
          {
            id: 0,
            title: "电商系统解决方案",
            img: require("../../static/images/xitong.png"),
          },
          {
            id: 1,
            title: "电商行业解决方案",
            img: require("../../static/images/hangye.png"),
          },
          {
            id: 2,
            title: "智慧行业",
            img: require("../../static/images/zhihui.png"),
          },
          {
            id: 3,
            title: "行业解决方案",
            img: require("../../static/images/hangye3.png"),
          },
        ],
        rightList: [
          {
            id: 0,
            list: [
              {
                id: 1,
                title: "直播电商解决方案",
                desc: "新兴营销，助力企业消费转化",
                icon: "HOT",
                url: "/solution/live",
              },
              {
                id: 6,
                title: "O2O在线商城解决方案",
                desc: "帮助企业实现上下游相互连通",
                url: "/solution/o2o",
              },
              {
                id: 5,
                title: "B2B批发商城系统一站式解决方案",
                desc: "一站式解决批发商城难题",
                url: "/solution/whole",
              },
              {
                id: 2,
                title: "B2B2C在线商城解决方案",
                desc: "打造生态级多商城系统盈利模式",
                url: "/solution/onlineShop",
              },
              {
                id: 0,
                title: "S2B2B2C电商供应链系统解决方案",
                desc: "构建完美创新电商模式",
                icon: "NEW",
                url: "/solution/supply",
              },

              {
                id: 28,
                title: "运动健身平台解决方案",
                desc: "平台涵盖了身体运动的数据、健身的指导等内容",
                url: "/solution/fitPlan",
              },
              {
                id: 4,
                title: "B2C自营品牌商城解决方案",
                desc: "助力企业快速进入电商时代",
                icon: "HOT",
                url: "/solution/brand",
              },

              {
                id: 7,
                title: "更多解决方案...",
                desc: "帮助更多企业实现商业成功",
                url: "",
              },
            ],
          },
          {
            id: 1,
            list: [
              {
                id: 0,
                title: "母婴电商解决方案",
                desc: "母婴电商解决方案",
                url: "/solution/mother",
              },
              {
                id: 1,
                title: "生鲜电商解决方案",
                desc: "生鲜电商解决方案",
                url: "/solution/fresh",
              },
              {
                id: 2,
                title: "医药电商解决方案",
                desc: "医药电商解决方案",
                url: "/solution/medicine",
              },
            ],
          },
          {
            id: 2,
            list: [
              { id: 0, title: "智慧景区解决方案", desc: "智慧景区解决方案", url: "/solution/wisdom" },
              { id: 1, title: "智慧旅游解决方案", desc: "智慧旅游解决方案" },
              { id: 2, title: "智慧酒店解决方案", desc: "智慧酒店解决方案" },
            ],
          },
          {
            id:3,
            list:[]
          }
        ],
      },
    };
  },
  mounted() {
    this.getHeaderList();
  },

  watch: {
    $route(to, from) {
      this.$router.go(0);
    },
    actIndex(newVal){
      if(this.status){
        this.actIndex = 3;
      }
    },
    imgList(newVal){
      if(!newVal && newVal.length == 0) return;
      this.imgSwiper();
    }
  },

  methods: {
    getHeaderList() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/productandsolve",
        null,
        (res) => {
          // console.log(res)
          let list = [
            { url: "/wisdomMarket/spread", desc: "智慧传播" },
            { url: "/wisdomMarket/case", desc: "智慧案场" },
            { url: "/wisdomMarket/channel", desc: "智慧渠道" },
          ];
          if (res.code == 1) {
            this.productDown = res.data.productDown;
            this.productDown.rightList[0].list[0].insideList = list;
            this.productDown.rightList[0].list[0].noShow = true;
            // this.solveDown = res.data.solveDown;
          }
        }
      );


      this.$http.get(
        "https://eartisanapplets.wsandos.com/api/industry_case/CaseList",
        null,
        (res) => {
          let newArr = [];
          const arr = res.data.case_list;
          const name = res.data.title_list.title;
          const sub_name = res.data.title_list.sub_title;
          arr.map((item) => {
            if(item.status != 1) return;
            newArr.push({
              id:item.id,
              title:item.name,
              desc:item.sub_name,
              url: `/solution/proGramme?id=${item.id}`,
              idd:item.id,
              name:name,
              sub_name:sub_name,
            })
          })
             newArr.push({
                id: 9,
                title: "更多解决方案...",
                desc: "帮助更多企业实现商业成功",
                url: "",
              })
          
          if(newArr.length > 0){
            this.solveDown.rightList[3].list = newArr;
          }

        }
      );
    },
    jumpService() {
      this.$addConsult()
    },
    mouseEnter(index) {
      if (this.enterIndex != index) {
        this.enterIndex = index;
      }
      // if (index == 2) {
      //   this.showProductModal = true;
      //   this.showSolveModal = false;
      // }
      if (index == 3) {
        this.showSolveModal = true;
        this.showProductModal = false;
        this.changeTabs(0, 'solve');
        return;
      }
      this.showSolveModal = false;
    },
    mouseLeave() {
      this.enterIndex = -1;
    },
    mouseLeaveModal() {
      this.showProductModal = false;
      if(this.status == true) return;
      this.showSolveModal = false;
    },
    pageUrl(url, id) {
      if(id == 3){
        this.actIndex = id;
        this.showSolveModal = true;
        this.status = !this.status;
      }
      if ((id != 0 && url != "/") || (id == 0 && url == "/")) {
        this.$router.push(url);
        this.status = false;
        this.actIndex = id;
        this.showSolveModal = false;
      }
    },
    imgSwiper() {
      this.$nextTick(()=>{
        let swiper = new Swiper(".header-swiper-container", {
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: { disableOnInteraction: false }
      });
      })
    },
    changeTabs(index, type) {
      if (type == "solve" && this.solveIndex != index) {
        this.solveIndex = index;
      } else if (type == "product" && this.productIndex != index) {
        this.productIndex = index;
      }
    },
    jumpPages(url, id,title,sub_name) {
      // console.log(url, id)
      if(title){
        window.sessionStorage.setItem('idd', id);
        window.sessionStorage.setItem('name', title);
        window.sessionStorage.setItem('sub_name', sub_name);
      }
      if (url && url != "") {
        this.$router.push(url);
        this.status = false;
        this.showSolveModal = false;
      } else {
        this.$addConsult()
        return;
      }
    },
    console(e) {
      // console.log(e)
    }
  },
  computed: {
    showSwiper() {
      return this.imgList.length;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varible.styl';


.header >>> .header-swiper-container {
  position: relative;
  width: 100%;
  height: 420px;

  img {
    width: 100%;
    height: 100%;
  }
}


.header >>> .swiper-pagination{
  bottom: 35px;
  width: 100%;
}


.header >>> .swiper-pagination-bullet {
  width: 16px;
  height: 6px;
  display: inline-block;
  background: $homeColor;
  opacity: 0.3;
  margin: 0 5px;
  border-radius: 3px;
}

.header >>> .swiper-pagination-bullet-active {
  width: 40px;
  opacity: 1;
  background-color: $yellow;
}

.header >>>  .header-swiper-container img{
  object-fit:cover;
}

.page-tabs {
  position: absolute;
  box-sizing: border-box;
  display: flex;
  top: 100px;
  left:50%;
  z-index: 11;
  background-color: #fff;
  width: 1920px;
  box-shadow: 0px 0px 17px 3px rgba(204, 204, 204, 0.5);
  padding: 38px 0 0 276px;
  height: 311px;
  transform: translateX(-50%);

  span {
    font-size: 16px;
    font-weight: 400;
    color: #333333;
  }

  .tab-options {
    line-height: 50px;
    border-right: 1px solid #EEE;
    width: 180px;

    .option {
      display: flex;
      align-items: center;
      cursor: pointer;
      width: 180px;
    }

    .option.active {
      position: relative;
    }

    .option.active::before {
      content: '';
      position: absolute;
      top: 15px;
      left: 179px;
      width: 2px;
      height: 20px;
      background: #FFC000;
    }

    span {
      padding-left: 5px;
    }
  }

  .tab-content {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    line-height: 28px;
    padding-left: 80px;
    padding-top: 10px;

    .item {
      margin-right: 80px;
      height: 80px;
      font-weight: 400;
      padding: 0 40px -20px 40px;
      cursor: pointer;

      h2 {
        display: block;
        width: 350px;
        font-size: 16px;
        color: #333333;
      }

      p {
        font-size: 12px;
        color: #999999;
      }
    }

    .item.solve {
      width: 30%;
      margin-right: 0;
    }
    

    .item.sys {
      width: 33%;
    }

    h2:hover, p:hover {
      color: #FFC000;
    }

    .item.sms {
      width: 100%;
    }
  }
}

.header {
  position: relative;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  box-sizing: border-box;
  height: 420px;
  background-repeat: no-repeat;
  background-size: cover;

  .big-title {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 50px;
    flex-direction: column;
    width: 100%;
    height: 420px;

    h2 {
      font-size: 30px;
      font-weight: bold;
      color: #fff;
    }

    p {
      margin-top: 2px;
      font-size: 18px;
      color: #fff;
      white-space: pre-line;
      text-align: center;
      line-height: 28px;
      max-width:514px
    }

    .btn {
      font-size: 16px;
      text-align: center;
      line-height: 50px;
      height: 50px;
      width: 150px;
      border: 1px solid #fff;
      border-radius: 30px;
      color: #fff;
      margin-top: 30px;
      cursor: pointer;
      transition: all .8s;
    }

    .btn:hover {
      background: #fff;
      color: #333;
    }
  }

  .header-nav {
    position: absolute;
    z-index: 2;
    min-width: 1300px;
    max-width: 1400px;
    margin: 0 auto;
    top: 16px;
    left: 80px;
    right: 0;
    transition: all .5s;

    .header-logo {
      float: left;
      width: 12%;

      img {
        width: 100%;
      }
    }

    .header-list {
      position: absolute;
      display: flex;
      width: 65%;
      right: 0;
      top: 25px;
      line-height: 16px;
      margin-top: -8px;

      li {
        display: inline-block;
        flex: 1;
        font-size: 16px;
        color: $homeColor;
        cursor: pointer;
        text-align: center;

        span.active {
          display: block;
          margin: 16px auto 0;
          content: '';
          width: 26%;
          border-bottom: 1px solid #FFC000;
        }

        div {
          position: relative;
          top: 6px;

          p {
            padding: 5px;
            background: $yellow;
          }
        }
      }

      li.active {
        color: #FFC000;
      }
    }
  }
  @media (max-width:1400px){
  .header-nav {
    left: 10px;
  }
}
}



.certification{
    position: absolute;
    top: 0px;
    left: 200px;
    width: 208px !important;
    height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/pc/Header.vue